import CircularProgress from "@mui/material/CircularProgress";
import { getColorHexCodeByColorName as token } from "../../tokens";

/**
 * View shown while the plugin is acquiring an auth token via Office Dialog
 * API + MSAL. Replaces the workflow stepper for the brief window between
 * the user clicking Automate and the substrate accepting our authenticated
 * `execute` call. Without this, the stepper would display fake "Parsing
 * email…" progress before any work has actually started.
 */
export default function AuthProgress() {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1 className="text-display-xs text-primary-gray-light-900">
          Authorizing
        </h1>
        <p className="text-sm text-primary-gray-light-600 pt-[0.438rem]">
          Verifying your access to ora. A sign-in dialog may appear briefly.
        </p>
      </div>
      <section className="w-full flex flex-row see-possible-tile-shadow py-8 px-4 items-center justify-center">
        <CircularProgress
          size={36}
          thickness={4.5}
          sx={{ color: token("sunrise") }}
        />
      </section>
    </div>
  );
}
